(function($){

  $.fn.extend({
    appSizer: function(){
      var h = $(window).height();
      var ih = window.innerHeight;
      var oh = window.outerHeight;
      var iw = window.innerWidth;
      var ow = window.outerWidth;
      var w = $(window).width();
      var ratio = w / h;
      var headerH = $("header").height();
      var contH = h - (headerH);

      $("html, body, .root-app__wrap, .root-app__cont, .root-app__cont section").height(contH);
      $("#gmap").height(contH).width(w);

      $(".sec__iframe iframe").css('min-height', contH);
    }
   });

  let pr

  $(function(){
    var action;
    var $iframe = $(".sec__iframe iframe");

    if( $("html").is(".iphone") ){
      action = 'tap';
    } else{
      action = 'click';
    }

    if( $("body").is(".root-app") ){

      // あらゆるサイズを揃える
      $.fn.appSizer();
      $(window).on('load resize orientationchange', function(){
        $.fn.appSizer();
      });

      // スマホの向き変更でiframeの高さ取得
      $(window).on('orientationchange', function(){
        setTimeout(function(){
          $iframe.iframeAutoHeight();
        }, 500);
      });

      // main-menu
      $("a[data-href]").on(action, function(){
        var id = $(this).attr("data-href");
        $("body").removeClass("is-iframe");
        $("body").attr("id", "cr-" + id);
      });

      // GMAP
      //------------------------------------------------------------
      var par = $(".sec__map");
      if( $("#gmap").length > 0 ){

        // var icSpot = new google.maps.MarkerImage("/design/img/spr_icon/pin-default.png",
        // null,null,null,
        // new google.maps.Size(39, 47.5));

        // var firstPoint = "";
        // var lastPoint = "";
        // var way = [];

        // var latlng = new google.maps.LatLng(34.971557, 135.942785);
        // map = new google.maps.Map(document.getElementById("gmap"), {
        //     center: latlng,
        //     zoom: 12,
        //     mapTypeId: google.maps.MapTypeId.ROADMAP,
        //     mapTypeControl: false,
        //     streetViewControl: false
        // });

        // var marker = new google.maps.Marker({
        //     position: latlng,
        //     map: map,
        //     icon : icSpot,
        //     title: "びわこ文化公園"
        // });

        // // ダミー現在地
        // var latGeo = 34.986982;
        // var lngGeo = 135.925278;

        // var circleOptions = {
        //     center: new google.maps.LatLng(latGeo, lngGeo),
        //     radius: 2000,
        //     strokeWeight: 1,
        //     strokeColor: "#41a4dd",
        //     strokeOpacity: 0.5,
        //     fillColor: "#41a4dd",
        //     fillOpacity: 0.5
        // };

        // var circle = new google.maps.Circle(circleOptions);
        // circle.setMap(map);

        // // var map;
        // var directionsDisplay = new google.maps.DirectionsRenderer({map: map});
        // var directionsService = new google.maps.DirectionsService();
        // var travel = google.maps.TravelMode.DRIVING;

        // // 経由地追加ボタン
        // $(".root-list").on(action, ".bt-add", function(event){
        //     event.preventDefault();
        //     var root = $(".root-list li");
        //     if (root.length >= 12) {
        //         return;
        //     }
        //     var ele = $(root[1]).clone();
        //     $(".touch", ele).removeClass("touch");
        //     ele.find("input").val("");
        //     ele.insertAfter($(this).parents("li"));
        // });

        // // 上下入れ替えボタン
        // $(".root-list").on(action, ".bt-reverse", function(event){
        //     event.preventDefault();
        //     var li1 = $(this).parents("li");
        //     var li2 = li1.next();
        //     var input1 = li1.find("input");
        //     var input2 = li2.find("input");
        //     var str = input1.val();
        //     input1.val(input2.val());
        //     input2.val(str);
        //     searchRoute();
        // });

        //  // 自動車モードへの切り替え
        //  $("[data-mode='driving']").on(action, function(event){
        //      event.preventDefault();
        //      travel = google.maps.TravelMode.DRIVING;
        //      searchRoute();

        //      var mode = $(this).attr("data-mode");
        //      // $(".block-root").attr("data-crrMode", mode);
        //      $("[data-mode]").removeClass("active");
        //      $("[data-mode='driving']").addClass("active");
        //  });

        //  // 徒歩モードへの切り替え
        // $("[data-mode='walking']").on(action, function(event){
        //      event.preventDefault();
        //      travel = google.maps.TravelMode.WALKING;
        //      searchRoute();

        //      var mode = $(this).attr("data-mode");
        //      // $(".block-root").attr("data-crrMode", mode);
        //      $("[data-mode]").removeClass("active");
        //      $("[data-mode='walking']").addClass("active");
        //  });

        // // ルート検索実処理
        // var searchRoute = function () {
        //     var firstPoint = "";
        //     var lastPoint = "";
        //     var way = [];

        //     $(".root-list li").each(function(){
        //         var val = $("dd input", this).val();

        //         if( $("dd input", this).attr("data-latlng") ){
        //             val = $("dd input", this).attr("data-latlng");
        //         }

        //         if( $(this).is(":first-child") ){
        //             firstPoint = val;
        //         }

        //         else if( $(this).is(":last-child") ){
        //             lastPoint = val;
        //         }

        //         else if (val) {
        //             way.push({location: val});
        //         }
        //     });

        //     directionsDisplay.setMap(map);
        //     directionsService.route({
        //         origin: firstPoint,
        //         destination: lastPoint,
        //         waypoints: way,
        //         travelMode: travel
        //     },

        //     function(result, status){
        //         if (status == google.maps.DirectionsStatus.OK) {

        //             directionsDisplay.setDirections(result);
        //             $("#root-results ul").empty();
        //             var ul = $("#root-results ul");
        //             for (var i in result.routes[0].legs) {

        //                 // この数値を足せば合計距離が出る

        //                 // この数値を足せば合計時間が出る

        //                 for (var j in result.routes[0].legs[i].steps) {
        //                     ul.append($("<li>").html(result.routes[0].legs[i].steps[j].instructions));
        //                 }
        //             }

        //             $("#root-results").addClass("active");
        //         }
        //     });
        // };

        // ルート作成 クリック
        $(".bt-create").on(action, function(event){
          $("body").removeClass("is-iframe");
          $("body").attr("id", "cr-1");
          // searchRoute();
        });

        // infowindow内のボタンをクリック
        $(".mk-info .bt-start, .mk-info .bt-goal").live(action, function(){
          $("body").removeClass("is-iframe");
          $("body").attr("id", "cr-2");
        });

        // 出発地 or 目的地を設定
        $(".root-list li > dl").live(action, function(){
          var href = $(".bt-subSearch a", this).attr("data-iframe");
          $(".root-list input").removeAttr("data-target");
          pr = $(this).parents().filter("li");

          $("input", pr).attr("data-target", "true");

          // iframe関係の処理
          $iframe.attr("src", href);
          $("body").addClass("is-iframe");

          // iframeの高さを自動取得
          $iframe.iframeAutoHeight();

          $iframe.on('load', function(){
            var cont = $iframe.contents();
            var len = $(".post", cont).length;

            $(".post .bts a, .post .photo", cont[0]).on('click', function(){
              // alert('ok');
              var post = $(this).parents().filter(".post");
              var postTitle = $(".title", post).text();
              var lat = post.data("lat");
              var lng = post.data("lng");



              $("body").removeClass("is-iframe");
              $("[data-target='true']").val(postTitle);
              $("[data-target='true']").attr("data-latlng", lat + ', ' + lng);
            });

            $(".check-list .toggle, .check-list2 .toggle", cont[0]).on('click', function(){
              // $iframe.iframeAutoHeight();
              var iframeHeight = $("#iframe-cont", cont[0]).height();
              $iframe.height(iframeHeight);

            });
          });
        });

        // $(".sec__iframe").on('tap', function(){
        //     $iframe.iframeAutoHeight();
        // });
      }
    }
  });
})(jQuery);



// WEBPACK FOOTER //
// ./_src/js/cont/root-app.js